module.exports = __webpack_public_path__ + "img/instagram.83c1913f.svg";